import {IBannerData} from "OK/banners/bannerNew/data/BannerDataNull";

export class BannerDataText implements IBannerData {
    text: string;

    constructor(text: string) {
        this.text = text;
    }
}